export default __webpack_public_path__ + "static/media/avatar.cfe9f79c.jpg";